// extracted by mini-css-extract-plugin
module.exports = {"challenge":"Challenge_challenge__1UFhw"};